<template>
  <div class="app-container">
    <div class="top">
      <el-row :gutter="10">
        <el-col :span="4">
          <el-input
            v-model.trim="adqAdvertListParams.adgroup_id"
            placeholder="请输入广告组ID"
          >
            <i
              slot="prefix"
              class="el-input__icon el-icon-search"
            />
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input
            v-model.trim="adqAdvertListParams.account_id"
            placeholder="请输入广告主ID"
          >
            <i slot="prefix" class="el-input__icon el-icon-search" />
          </el-input>
        </el-col>
        <el-button type="primary" @click="fetchAdqAdvertList">搜索</el-button>
        <el-button
          type="primary"
          @click="resetTencentAdqAdverList"
        >重置</el-button>
      </el-row>
    </div>
    <div class="main">
      <el-table
        v-loading="loading"
        :data="adqAdvertList ? adqAdvertList : []"
        style="width: 100%"
        :row-class-name="'aaaa'"
        :row-key="getRowKeys"
        @select="multipleChoice"
        @select-all="multipleChoice"
      >
        <el-table-column
          type="selection"
          width="55"
          :data-index="1"
          :reserve-selection="true"
        />
        <el-table-column prop="account_name" label="广告主名称" />
        <el-table-column prop="account_id" label="广告主id" />
        <el-table-column prop="adgroup_name" label="广告组名称" />
        <el-table-column prop="adgroup_id" label="广告组id" />
      </el-table>
      <PaginationRight
        :total="pageTotal"
        :page.sync="adqAdvertListParams.page"
        :limit.sync="adqAdvertListParams.page_size"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <div style="float: right; margin: 10px">
        <el-button type="primary" size="" @click="submit">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { adgroupsindex } from '@/api/customer.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  name: 'CopyAdqAdvertManage',
  components: {
    PaginationRight
  },
  // CopyAdqAdDialog,
  data() {
    return {
      loading: false,
      loadingGlobalWindow: false,
      pageTotal: 0,
      adqAdvertListParams: {
        adgroup_id: null,
        account_id: this.$route.query.account_id || null,
        page: 1,
        page_size: 10
      },
      adqAdvertList: null,
      adgroup_ids: null,
      alone: null,
      allow_template: null,
      adgroup_items: [],
      dialogVisible: false,
      sync_copy: false,
      copy_ad_adp_adgroup_id: null,
      copy_ad_adp_adgroup_ids: [],
      copy_ad_adp_account_id: null,
      type: null
    }
  },
  computed: {
    isShow() {
      let blo = false
      console.log('this.adgroup_items:', this.adgroup_items)
      if (this.adgroup_items.length !== 0) {
        const account_id = this.adgroup_items[0].account_id
        // eslint-disable-next-line eqeqeq
        const isAllAccountIdsEqual = this.adgroup_items.every(
          // eslint-disable-next-line eqeqeq
          (item) => item.account_id == account_id
        )

        if (isAllAccountIdsEqual) {
          blo = true
        } else {
          blo = false
        }
      }
      return blo
    }
  },
  created() {
    this.fetchAdqAdvertList()
    console.log(this.$route.query)
    window.aaaaa = this
  },
  methods: {
    fetchPageSize(e) {
      this.adqAdvertListParams.page_size = e
      this.fetchAdqAdvertList()
    },
    fetchCurrentPage(e) {
      this.adqAdvertListParams.page = e
      this.fetchAdqAdvertList()
    },
    submit() {
      this.$emit('bandarr', this.adgroup_ids)
    },
    // 获取广告列表
    fetchAdqAdvertList() {
      this.loading = true
      adgroupsindex(this.adqAdvertListParams).then((res) => {
        this.adqAdvertList = res.data.list
        this.pageTotal = res.data.count

        // this.allow_template = res.data.allow_template
        // this.loadTheFirstPin(this.adqAdvertList)
        // this.pageTotal = res.data.page_info.total_number
        this.loading = false
      })
    },
    // 重置公共广告
    resetTencentAdqAdverList() {
      this.adqAdvertListParams = {
        adgroup_id: null,
        account_id: this.$route.query.account_id || null,
        page: 1,
        page_size: 10
      }
      this.fetchAdqAdvertList()
    },
    multipleChoice(arr) {
      console.log('arr:', arr)
      this.adgroup_ids = arr.map((item) => {
        return item.adgroup_id
      })
      this.adgroup_items = arr
    },
    getRowKeys(row) {
      return row.adgroup_id
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.main {
  margin-top: 20px;
  video {
    width: 100px;
    height: 100px;
    object-fit: fill;
  }
  .shadowBox {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
  }
}
.titip {
  width: 154px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 这里是超出几行省略 */
  overflow: hidden;
}
</style>
